<template>
    <div>
        <rkm-area
            v-if="data.form.triagensNeonatal.length > 0"
            class="mb-2"
            no-margin-top
            title="Exames Avaliados"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col
                    v-for="(triagemNeonatal, index) in data.form.triagensNeonatal"
                    :key="index"
                    class="mb-2"
                    cols="6"
                >
                    <rkm-list-group>
                        <rkm-list-group-item class="rkm-list-group-item">
                            <rkm-row>
                                <rkm-col
                                    class="align-self-center"
                                    cols="12"
                                >
                                    <rkm-form-checkbox
                                        checked
                                        disabled
                                    >
                                        {{triagemNeonatal.descricao}}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>
                    </rkm-list-group>

                    <rkm-collapse
                        class="rkm-collapse"
                        visible
                    >
                        <rkm-row class="p-2">

                            <rkm-col cols="6">
                                <rkm-form-date-picker
                                    label="Data da solicitação"
                                    v-model="triagemNeonatal.solicitadoEm"
                                    readonly
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-date-picker
                                    label="Data da realização"
                                    v-model="triagemNeonatal.realizadoEm"
                                    readonly
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-date-picker
                                    label="Data do resultado"
                                    v-model="triagemNeonatal.resultadoEm"
                                    readonly
                                />
                            </rkm-col>

                            <rkm-col cols="12">
                                <rkm-form-textarea
                                    :value="triagemNeonatal.resultado"
                                    readonly
                                    rows="6"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col
                v-for="(triagemNeonatal, index) in data.form.triagemNeonatal"
                :key="index"
                class="mb-2"
                cols="6"
            >
                <rkm-list-group>
                    <rkm-list-group-item class="rkm-list-group-item">
                        <rkm-row>
                            <rkm-col
                                class="align-self-center"
                                cols="12"
                            >
                                <rkm-form-checkbox
                                    :checked="!!data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id)"
                                    @change.native="handletriagemNeonatalChange($event, triagemNeonatal.id)"
                                >
                                    {{triagemNeonatal.descricao}}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>

                <rkm-collapse
                    :visible="!!data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id)"
                    class="rkm-collapse"
                >
                    <rkm-row class="p-2">

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                v-if="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id)"
                                :max-date="data.additionals.dataAtual"
                                label="Data da solicitação"
                                v-model="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id).solicitadoEm"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                v-if="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id)"
                                :max-date="data.additionals.dataAtual"
                                label="Data da realização"
                                :min-date="others.moment(data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id).solicitadoEm).format('DD/MM/YYYY')"
                                v-model="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id).realizadoEm"
                                :validations="validations.realizadoEm"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                v-if="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id)"
                                :max-date="data.additionals.dataAtual"
                                label="Data do resultado"
                                :min-date="others.moment(data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id).realizadoEm).format('DD/MM/YYYY')"
                                v-model="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id).resultadoEm"
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-textarea
                                v-if="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id)"
                                :validations="validations.resultado"
                                placeholder="Resultado"
                                rows="6"
                                v-model="data.model.triagemNeonatal.find(t => t.id === triagemNeonatal.id).resultado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Others.
import moment from 'moment'

export default {
    computed: {
        validations() {
            return {
                resultado: {max: 500},
                realizadoEm: {required: true},
            }
        },
    },
    data: () => ({
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handletriagemNeonatalChange(event, id) {

            if (event.target.checked) {
                this.data.model.triagemNeonatal.push({
                    id: parseInt(id),
                    resultado: null,
                })
            } else {
                this.data.model.triagemNeonatal.splice(this.data.model.triagemNeonatal.findIndex(triagemNeonatal => triagemNeonatal.id === parseInt(id)) , 1)
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.2rem 0.2rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>